import { MouseEvent, useState } from 'react';

export const useModal = () => {
  const [open, setOpen] = useState<boolean>(false);

  const handleCloseModal = (e?: MouseEvent) => {
    e?.stopPropagation();
    setOpen(false);
  };

  const handleOpenModal = (e?: MouseEvent) => {
    e?.stopPropagation();
    setOpen(true);
  };

  return {
    open,
    handleCloseModal,
    handleOpenModal,
  };
};
